<template>
  <v-card class="zoox-component zoox-card-tabs" :class="{shadow}">
    <z-tabs
      ref="tabs"
      :android="android"
      :tabs="tabs"
      :value="value"
      :grow="grow"
      :dark="dark"
      :color="color"
      :touchless="touchless"
      @change="onChange"
    >
      <!--@slot Slot referente a tab selecionada. Seu nome é referente ao id de cada tab -->
      <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </z-tabs>
  </v-card>
</template>

<script>
import zTabs from '../Tabs/Tabs.vue'

/**
 * @displayName Tabs Card
 */
export default {
  name: 'ZTabsCard',
  components: {zTabs},
  props: {
    /**
     * Abas para serem criadas.
     *
     * @typedef Object {text:string,id:number,string}
     */
    tabs: {
      type: Array,
      required: true,
    },
    /**
     * Formata a aba com estilo do material
     */
    android: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Valor do v-model
     */
    value: {
      type: [String, Number],
      default: null,
    },
    /**
     * Flag para indicar que a tab deve ocupar todo o espaço disponível
     */
    grow: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para colocar sombra no card das abas
     */
    shadow: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que a cor precisa de um tema escuro
     */
    dark: {
      type: Boolean,
      default: false,
    },
    /**
     * Cor das abas e do slider caso seja do tipo android
     */
    color: {
      type: String,
    },
    /**
     * Flag para indicar que é sem touch. Não será passada de aba usando arrastar
     */
    touchless: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.setTabById(this.tabs[0].id)
  },
  methods: {
    /**
     * Método que permite escolher a tab programaticamente
     * @param {string} id - ID da aba que quer selecionar
     * @public
     */
    setTabById(id) {
      this.$refs.tabs.setTabById(id)
    },
    /**
     * Retorna o ID ta tab atual
     * @public
     */
    getCurrentTab() {
      return this.$refs.tabs.getCurrentTab()
    },
    onChange(value) {
      /**
       * Evento emitido ao trocar de aba
       *
       * @property {string} tabId - ID da aba selecionada
       */
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-card-tabs {
  border-radius: var(--component-card-radius) !important;
  box-shadow: none !important;

  &.shadow {
    box-shadow: var(--zoox-card-shadow) !important;
  }
}
</style>

<style lang="scss">
.zoox-card-tabs {
  .v-tabs,
  .v-slide-group__wrapper {
    border-radius: var(--component-card-radius) var(--component-card-radius) 0px
      0px;
  }
  .v-window {
    border-radius: 0 0 var(--component-card-radius) var(--component-card-radius);
  }
}
</style>
